// R223 — **THE ATTACHMENT PICKER, OUT WHERE R15's LAW CAN BE READ AT IT.**
//
// It came out to pay the R8 ceiling for R223's palm repair, and the reach it buys is real rather
// than incidental. R15's whole ruling lives on this one control: **what a file picker OFFERS and
// what the server's sniffer ACCEPTS are one declaration** (`src/uploadTypes.js`), because a picker
// that offers what the sniffer refuses costs her a whole upload before she is told no. Inside an
// eleven-thousand-line file that crossing could only ever be checked by a regex; out here a fixture
// IMPORTS the component and the roster and holds the two against each other.
//
// It is rendered at TWO call sites — the Ask Lala drawer and the Ask Lala page, which are one mind
// behind two doors by standing law — so a second copy of the accept attribute is exactly the drift
// R15 exists to make impossible. It takes its files as a callback and holds nothing but the input
// it clicks, so nothing about the extraction moved a pixel.
import { useRef } from "react";
import { Paperclip } from "lucide-react";
import { attachmentAccept } from "../uploadTypes.js";

export function AttachButton({ onFiles, disabled }: { onFiles: (files: FileList) => void; disabled?: boolean }) {
  const ref = useRef<HTMLInputElement | null>(null);
  return (
    <>
      <input
        ref={ref}
        type="file"
        multiple
        className="attach-input"
        accept={attachmentAccept()}
        onChange={(e) => { if (e.target.files?.length) onFiles(e.target.files); e.target.value = ""; }}
      />
      <button
        type="button"
        className="attach-btn"
        onClick={() => ref.current?.click()}
        disabled={disabled}
        aria-label="Attach a photo or a document"
        title="Attach a photo or a document"
      >
        <Paperclip size={16} />
      </button>
    </>
  );
}
